import { render, staticRenderFns } from "./AlmacenBonoIndex.vue?vue&type=template&id=40fc505c"
import script from "./AlmacenBonoIndex.vue?vue&type=script&lang=js"
export * from "./AlmacenBonoIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports